import { Descriptions } from "antd";
import moment from "moment";
import { FC, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from "react-router-dom";
import { getCommonCodeLabel } from "../../lib/store";
import { IArchive } from "../../models/archives.model";
import { RootState } from "../../store/rootReducer";
import Button from "../Button";
import ConfirmModal from "../modals/ConfirmModal";

interface IProps {
  codeId: string;
  archiveCode: number;
  path: string;
  data: IArchive|undefined;
  onDelete: () => void;
  setDownloadHistoryVisible: (visible: boolean) => void;
}

const ArchiveReader: FC<IProps> = ({
  codeId, archiveCode, path, data, onDelete, setDownloadHistoryVisible
}) => {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const { auth } = useSelector((state: RootState) => state.auth);

  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);

  return (
    <div className='comm-table__area rowType'>
      <Descriptions
        bordered
        column={4}
        size="small"
        labelStyle={{ width: '12.5%' }}
        contentStyle={{ width: '12.5%' }}
      >
        <Descriptions.Item label={t('archive.exam.column2')}>
          {getCommonCodeLabel(codeId, data?.archiveCategoryCode || '', i18n.language)}
        </Descriptions.Item>
        <Descriptions.Item label={t('common.column.writer')}>
          {data?.regMemKorName}
        </Descriptions.Item>
        <Descriptions.Item label={t('archive.learn.column4')}>
          {moment(data?.regDate).format('YYYY.MM.DD')}
        </Descriptions.Item>
        <Descriptions.Item label={t('archive.learn.column3')}>
          {data?.readCount}
        </Descriptions.Item>
        <Descriptions.Item label={t('common.column.title')} span={4}>
          {data?.title}
        </Descriptions.Item>
        <Descriptions.Item label={t('common.column.contents')} span={4}>
          <div dangerouslySetInnerHTML={{ __html: data?.content || '' }} />
        </Descriptions.Item>
        <Descriptions.Item label={t('archive.exam.column7')} span={4}>
          {
            data?.archiveFiles
              ? data?.archiveFiles.map(item => (
                <a
                  className="download-link btn-text mr-2"
                  href={item.fileLocation}
                  download={item.originalName}
                >
                  {item.originalName}
                </a>
              ))
              : '-'
          }
        </Descriptions.Item>
      </Descriptions>

      <div className="comm-bx__between">
        <div className="comm-btn__area">
          <Button
            className="btn-basic gray-line"
            text={t('common.button.list')}
            onClick={() => history.push(`${path}${location.search}`)}
          />          
        </div>
        <div className="comm-btn__area right">
          {
            auth?.hqYn === 'Y'
              ? (
                <>
                  <Button
                    className="btn-basic gray"
                    text={t('common.button.delete')}
                    onClick={() => setConfirmDeleteVisible(true)}
                  />
                  <Button
                    className="btn-basic pink-line"
                    text={t('common.button.edit')}
                    onClick={() => history.push(`${path}/${archiveCode}/edit${location.search}`)}
                  />
                </>
              )
              : null
          }
          {
            auth?.hqYn === 'Y' && auth?.groupNo === 1000
              ? (
                <Button
                  className="btn-basic pink-line"
                  text={t('archive.exam.button1')}
                  onClick={() => setDownloadHistoryVisible(true)}
                />
                )
              : null
          }
        </div>
      </div>

      {confirmDeleteVisible &&
        <ConfirmModal
          visible={confirmDeleteVisible}
          setVisible={setConfirmDeleteVisible}
          onConfirm={onDelete}
          titleText={t('system.menu.title6')}
          messageText={t('system.menu.text3')}
          confirmText={t('common.button.delete')}
          cancelText={t('common.button.cancel')}
        />
      }
    </div>
  ); 
}

export default ArchiveReader;
